/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/concatAll */
import{mergeAll as r}from"rxjs/dist/esm/internal/operators/mergeAll";function t(){return r(1)}export{t as concatAll};
//# sourceMappingURL=concatAll.mjs.map